import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast, Toaster } from "sonner";
import PublicNavbar from "../components/layout/PublicNavbar";
import { Button, Input } from "../components/common/Primitives";
import api, { formatApiError } from "../lib/api";
import Seo from "../components/Seo";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("If an account exists, a reset link has been sent.");
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen text-ink">
      <Seo
        title="Forgot Password | VenturaZ"
        description="Reset your VenturaZ password securely. Enter your email to receive a reset link valid for 30 minutes."
        path="/forgot-password"
        noindex
      />
      <Toaster richColors position="top-right" />
      <PublicNavbar />
      <section className="max-w-md mx-auto px-6 py-20">
        <div className="overline mb-3">PASSWORD RECOVERY</div>
        <h1 className="font-display text-3xl text-ink mb-6">Forgot password?</h1>
        {!sent ? (
          <form onSubmit={submit} className="glass rounded-lg p-6 space-y-4" data-testid="forgot-form">
            <p className="text-ink-soft text-sm">Enter the email associated with your VenturaZ account. We&apos;ll send a reset link valid for 30 minutes.</p>
            <Input label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required testId="forgot-email" />
            <Button type="submit" disabled={loading} className="w-full" data-testid="forgot-submit">
              {loading ? "Sending…" : "Send Reset Link"}
            </Button>
            <div className="text-sm text-ink-muted text-center pt-2">
              Remembered? <Link to="/login" className="text-gold">Back to login →</Link>
            </div>
          </form>
        ) : (
          <div className="glass rounded-lg p-6 text-center">
            <div className="overline mb-3">CHECK YOUR INBOX</div>
            <p className="text-ink-soft">If an account exists for <span className="font-mono text-gold">{email}</span>, a reset link is on its way.</p>
            <Link to="/login" className="mt-6 inline-block text-gold font-heading">Back to login →</Link>
          </div>
        )}
      </section>
    </div>
  );
}
